export const ACCOUNT_FIELDS = {
  firstname: {
    id: 'firstname',
    required: true,
  },
  lastname: {
    id: 'lastname',
    required: true,
  },
  email: {
    id: 'email',
    required: true,
  },
  phone: {
    id: 'phone',
    required: true,
  },
};

export const CONTACT_FIELDS = {
  firstname: {
    id: 'firstname',
    required: true,
  },
  email: {
    id: 'email',
    required: true,
  },
  message: {
    id: 'phone',
    required: true,
  },
  rating: {
    id: 'rating',
    required: false,
  },
};
